module.exports = __webpack_public_path__ + "static/media/bolinhobacalhau45.8c3bc9bf.webp";